import { createFileRoute } from '@tanstack/react-router';
import { call } from '@hlt/web-kit/api';
import { prefetch } from '@/app/prefetch';
import { publicIdParam, resolveResource } from '@/app/route-ids';
import { AuditDetailPage } from '@/features/audits/detail/audit-detail-page';

export const Route = createFileRoute('/_app/w/$workspaceId/audits/$auditId/')({
    params: publicIdParam('auditId'),
    staticData: {
        crumbs: [{ label: 'shell.audits', to: '/w/$workspaceId/audits' }, { label: 'shell.crumbAudit' }],
    },
    beforeLoad: async ({ context, params, location }) =>
        await resolveResource({
            ref: params.auditId,
            collection: 'audits',
            location,
            read: async () =>
                await call('getAudit', { params: { ...context.workspaceScope, auditId: params.auditId } }),
        }),
    loader: ({ context, params }) => prefetch.audit(context.queryClient, context.workspaceScope, params.auditId),
    component: function AuditDetailRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        const { auditId } = Route.useParams();
        return <AuditDetailPage organizationId={organizationId} workspaceId={workspaceId} auditId={auditId} />;
    },
});
